export function formatStatus(val) {
    console.log("formatStatus", val)
    //debugger;
    let label = val == 1 ? this.$t('status.enable') : this.$t('status.disable');
    // let type=val==1?"success":"danger";
    return label;
}


export function formatCommissionStatus(val) {
    return ({ 1: '待结算', 2: '已结算' })[val] || '-'
}